/*==================================================
 *  Localization of labellers.js
 *==================================================
 */

/* The Dutch do not capitalize months
*/

Timeline.GregorianDateLabeller.monthNames["nl"] = [
 "jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"
];



//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/scripts/l10n/nl/labellers.js
// module id = 588
// module chunks = 3